import { t } from "../i18n/index.js";
import "./confirmDialog.css";

/**
 * Una pregunta de si o no, con la cara del juego y no la del navegador.
 * `window.confirm` congela la pestaña y en movil sale con el nombre del dominio
 * encima: para "¿seguro que te vas?" sobra.
 */
export interface ConfirmOptions {
  title: string;
  body: string;
  confirm: string;
  cancel?: string;
}

export function confirmDialog(opts: ConfirmOptions, root: HTMLElement = document.body): Promise<boolean> {
  const overlay = document.createElement("div");
  overlay.className = "confirm-dialog";
  overlay.setAttribute("role", "alertdialog");
  overlay.setAttribute("aria-modal", "true");
  overlay.setAttribute("aria-labelledby", "confirm-dialog-title");
  overlay.innerHTML = `
    <div class="confirm-dialog-backdrop" data-cd-cancel></div>
    <div class="confirm-dialog-sheet">
      <h2 id="confirm-dialog-title"></h2>
      <p></p>
      <div class="confirm-dialog-actions">
        <button type="button" class="confirm-dialog-cancel" data-cd-cancel></button>
        <button type="button" class="confirm-dialog-ok" data-cd-ok></button>
      </div>
    </div>`;
  overlay.querySelector("h2")!.textContent = opts.title;
  overlay.querySelector("p")!.textContent = opts.body;
  const cancelBtn = overlay.querySelector<HTMLButtonElement>("button[data-cd-cancel]")!;
  const okBtn = overlay.querySelector<HTMLButtonElement>("[data-cd-ok]")!;
  cancelBtn.textContent = opts.cancel ?? t("Cancelar");
  okBtn.textContent = opts.confirm;
  root.appendChild(overlay);

  return new Promise((resolve) => {
    const done = (value: boolean): void => {
      overlay.remove();
      resolve(value);
    };
    for (const el of overlay.querySelectorAll("[data-cd-cancel]")) el.addEventListener("click", () => done(false));
    okBtn.addEventListener("click", () => done(true));
    overlay.addEventListener("keydown", (event) => {
      // Que el Esc no llegue a la ventana: alli es "salir del partido", y
      // volveria a abrir esta misma pregunta.
      event.stopPropagation();
      if (event.key === "Escape") {
        event.preventDefault();
        done(false);
      }
    });
    // Por defecto, quedarse: lo irreversible no puede estar a un Enter.
    cancelBtn.focus({ preventScroll: true });
  });
}
